import { FC } from 'react';
import { useSetAtom } from 'jotai';
import type { AddWellPayload } from './types-well';
import { addWellAtom, wellOverviewUrl } from './atoms/wells';
import { WellPickerPanel } from '../../afe-catalog/structuring/well-picker-panel';

// DO Add Well. Thin DO-specific wrapper over the SHARED `WellPickerPanel`
// (AFE-owned, prop-parameterized): supplies the copy + the DO `addWellAtom`
// mutation and wraps the resolved selection under the `well` payload key. POSTs
// to .../division_order_structuring/wells (the well collection). Passes
// `selectorPageContent` so the slide-in anchors to the DO shell root.

interface Props {
  open: boolean;
  documentId: number | string;
  onClose: () => void;
  onAdded: () => void;
}

export const AddWellPanel: FC<Props> = ({
  open,
  documentId,
  onClose,
  onAdded,
}) => {
  const addWell = useSetAtom(addWellAtom);

  return (
    <WellPickerPanel
      open={open}
      onClose={onClose}
      title="Add Well"
      subtitle="Select a well to add to this document, or create an imported one."
      idPrefix="do-aw"
      selectorPageContent=".do-structuring-shell"
      primaryButtonText={{ search: 'Add Well', create: 'Create & Add' }}
      onSubmit={(selection, { setPending, setError }) => {
        // Narrow per branch so the discriminated `AddWellPayload` distributes
        // (TS won't assign `{ well: A | B }` to `{ well: A } | { well: B }`).
        const payload: AddWellPayload =
          selection.kind === 'existing_well'
            ? { well: selection }
            : { well: selection };
        setPending(true);
        setError(null);
        addWell({
          url: wellOverviewUrl(documentId),
          method: 'POST',
          data: payload,
          onSuccess: () => {
            setPending(false);
            onAdded();
          },
          onError: (m) => {
            setPending(false);
            setError(m ?? 'Failed to add well.');
          },
        });
      }}
    />
  );
};
